import { NgModule } from '@angular/core';
import { Routes, RouterModule} from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { PAREmployeeComponent } from './components/par_employees/par_employees.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { DownloadControlTestComponent } from './components/download-control-test/download-control-test.component';
import { MasterComponent } from './components/master/master.component';
import { AgentsearchlistComponent } from './components/agentsearchlist/agentsearchlist.component';
import { UploadControlTestComponent } from './components/upload-control-test/upload-control-test.component';;
import { SubmasterComponent } from './components/submaster/submaster.component';
import { RoleGuardService as RoleGuard } from './security/role-guard.service';
import { ParNavComponent } from './components/par-nav/par-nav.component';
import { LocationRoutesComponent } from './components/location-routes/location-routes.component';
import { EmployeeRoutesComponent } from './components/employee-routes/employee-routes.component';
import { ParemployeeRoutesComponent } from './components/paremployee-routes/paremployee-routes.component';
import { ManageUsersComponent } from './components/manage-users/manage-users.component';
import { ManageComplaintsComponent  } from './components/manage-complaints/manage-complaints.component';
import { ParComplaintsRegionStateMappingComponent } from './components/par-complaints-region-state-mapping/par-complaints-region-state-mapping.component';
import { OktaAuthGuard } from '@okta/okta-angular';
import { LogoutComponent } from './components/logout/logout.component';
import { OktaCustomCallbackComponent } from './components/okta-custom-callback/okta-custom-callback.component';

enum roles {
  PARAdmin = 4,
  Client = 8,
  siteAdmin = 16,
  QAC = 1,
  ResolutionManager = 128    
}


const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'implicit/callback',
    component: OktaCustomCallbackComponent
  },
  {
    path: 'logout',
    component: LogoutComponent
  },
  
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    component: HomeComponent,
	  canActivate: [OktaAuthGuard],
    children: [
    ]
  },
  {
    path: '',
    component: MasterComponent,
    canActivate: [OktaAuthGuard],
    children: [
      {
        path: 'maindashboard',
        component: DashboardComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRole: roles.QAC | roles.PARAdmin | roles.siteAdmin
        }
      },
      {
        path: 'manageusers',
        component: ManageUsersComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRole: roles.siteAdmin
        }
      },
      {
        path: 'par/dashboard/:docType',
        component: ParNavComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRole:  roles.PARAdmin | roles.Client | roles.siteAdmin
        }
      },
      {
        path: 'par/insurance/:docType',
        component: ParNavComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRole:  roles.PARAdmin | roles.Client | roles.siteAdmin
        }
      },
      {
        path: 'par/license/:docType',
        component: ParNavComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRole:  roles.PARAdmin | roles.Client | roles.siteAdmin
        }
      },
      {
        path: 'par/duediligence/:docType',
        component: ParNavComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRole:  roles.PARAdmin | roles.Client | roles.siteAdmin
        }
      },
      {
        path: 'par/staterequirements/:docType',
        component: ParNavComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRole:  roles.PARAdmin | roles.Client | roles.siteAdmin
        }
      },
      {
        path: 'par/summary/:docType',
        component: ParNavComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRole:  roles.PARAdmin | roles.Client | roles.siteAdmin
        }
      },
      {
        path: 'par/summaryClient/:docType',
        component: ParNavComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRole:  roles.PARAdmin | roles.Client | roles.siteAdmin
        }
      },
      {
        path: 'par/employee/:docType',
        component: ParNavComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRole:  roles.PARAdmin | roles.Client | roles.siteAdmin
        }
      },
      {
        path: 'par/changelog/:docType',
        component: ParNavComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRole:  roles.PARAdmin | roles.Client | roles.siteAdmin
        }
      },
      {
        path: 'agent/dashboard/:agentId/:docType',
        component: SubmasterComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRole:  roles.QAC | roles.PARAdmin | roles.Client | roles.siteAdmin 
        }
      },
      {
        path: 'agent/duediligence/:agentId/:docType',
        component: SubmasterComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRole: roles.QAC | roles.PARAdmin | roles.Client | roles.siteAdmin 
        }
      },
      {
        path: 'agent/summary/:agentId/:docType',
        component: SubmasterComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRole: roles.QAC | roles.PARAdmin | roles.Client | roles.siteAdmin 
        }
      },
      {
        path: 'agent/location/:agentId/:docType',
        component: SubmasterComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRole: roles.QAC | roles.PARAdmin | roles.Client | roles.siteAdmin 
        }
      },
      {
        path: 'agent/insurance/:agentId/:docType',
        component: SubmasterComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRole: roles.QAC | roles.PARAdmin | roles.Client | roles.siteAdmin 
        }
      },
      {
        path: 'agent/staterequirements/:agentId/:docType',
        component: SubmasterComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRole: roles.QAC | roles.PARAdmin | roles.Client | roles.siteAdmin 
        }
      },
      {
        path: 'agent/agentemployee/:agentId/:docType',
        component: SubmasterComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRole: roles.QAC | roles.PARAdmin | roles.Client | roles.siteAdmin 
        }
      },
      {
        path: 'agent/license/:agentId/:docType',
        component: SubmasterComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRole: roles.QAC | roles.PARAdmin | roles.Client | roles.siteAdmin 
        }
      },
      {
        path: 'agent/changelog/:agentId/:docType',
        component: SubmasterComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRole: roles.QAC | roles.PARAdmin | roles.Client | roles.siteAdmin
        }
      },
      {
        path: 'par-admin/agents',
        component: DashboardComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRole:  roles.PARAdmin | roles.siteAdmin
        }
      },
      {
        path: 'agentsearchlist',
        component: AgentsearchlistComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRole: roles.QAC | roles.Client  | roles.PARAdmin |  roles.siteAdmin
        }
      },
      {
        path: 'agent/location/:agentId/:docType/:locationId',
        component: LocationRoutesComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRole: roles.QAC | roles.Client | roles.PARAdmin |  roles.siteAdmin 
        }
      },
      {
        path: 'agent/agentemployee/:agentId/:docType/:employeeId',
        component: EmployeeRoutesComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRole: roles.QAC | roles.Client | roles.PARAdmin |  roles.siteAdmin 
        }
      },
      {
        path: 'par/employee/:docType/:employeeId',
        component: ParemployeeRoutesComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRole:  roles.PARAdmin | roles.Client | roles.siteAdmin
        }
      },
      {
        path: 'par/managecomplaints',
        component: ManageComplaintsComponent ,
        canActivate: [RoleGuard],
        data: {
          expectedRole:  roles.QAC | roles.ResolutionManager | roles.siteAdmin
        }
      },
      {
        path: 'par/regionstatemapping',
        component: ParComplaintsRegionStateMappingComponent ,
        canActivate: [RoleGuard],
        data: {
          expectedRole: roles.ResolutionManager
        }
      },
    ]
  },
  {
    path: 'par-employee-admin',
    canActivate: [OktaAuthGuard],
    component: PAREmployeeComponent
  },
  {
    path: 'download',
    component: DownloadControlTestComponent,
  }, {
    path: 'lambdaUpload',
    component: UploadControlTestComponent,
  }
] 

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts